/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ leheküljel',
  jump_to: 'Hüppa',
  jump_to_confirm: 'Kinnitage',
  page: '',

  // Pagination.jsx
  prev_page: 'Eelmine leht',
  next_page: 'Järgmine leht',
  prev_5: 'Eelmised 5 lehekülge',
  next_5: 'Järgmised 5 lehekülge',
  prev_3: 'Eelmised 3 lehekülge',
  next_3: 'Järgmised 3 lehekülge'
};
